import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import UserSelector from './UserSelector';
import { locale } from '../../common/localization/localizationService';
import './impersonation-manager.scss';
import Spinner from '../shared/spinner/Spinner';

class ImpersonationManager extends PureComponent {
  constructor(props) {
    super(props);

    this.handleUserChange = this.handleUserChange.bind(this);
    this.startImpersonation = this.startImpersonation.bind(this);
    this.stopImpersonation = this.stopImpersonation.bind(this);

    this.state = {
      selectedUser: {
        userName: props.impersonatedUser.impersonatedUser,
        impersonatedCustomerId: props.impersonatedUser.impersonatedCustomerId,
      },
      waitingInProgress: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.impersonatedUser !== this.props.impersonatedUser) {
      this.props.vehicleTrackingActions.getVehicles();
      if (!this.props.impersonatedUser) {
        this.props.userActions.getUsers();
        this.props.customerActions.getCustomers();
      }
    }
  }

  handleUserChange(option, event) {
    if (event.action === 'select-option' && option.value) {
      this.setState({
        selectedUser: {
          userName: option.value.userName,
          impersonatedCustomerId: option.value.customerId,
        },
      });
    } else {
      this.setState({
        selectedUser: {
          userName: null,
          impersonatedCustomerId: null,
        },
      });
    }
  }

  componentDidMount() {
    if (!this.props.impersonatedUser) {
      this.props.userActions.getUsers();
      this.props.customerActions.getCustomers();
    }
  }

  startImpersonation() {
    const { authActions, settingsActions } = this.props;

    this.setState({ waitingInProgress: true });
    authActions.setImpersonatedUser(this.state.selectedUser);
    settingsActions.getDataButtons();
    settingsActions.getVisibleFields();
    settingsActions.getCompanySettings();

    setTimeout(() => this.setState({ waitingInProgress: false }), 1000);
  }

  getCustomerIdOfUser(userName) {
    const allUsers = this.props.users;
    const user = this.findObjectByProperty(allUsers, 'userName', userName);
    return user ? user.customerId : null;
  }

  findObjectByProperty(props, key, value) {
    for (const propKey in props) {
      if (Object.hasOwn(props, propKey)) {
        const array = props[propKey];
        for (const obj of array) {
          if (obj[key] === value) {
            return obj;
          }
        }
      }
    }
    return null;
  }

  stopImpersonation() {
    const { authActions, settingsActions } = this.props;

    authActions.resetImpersonatedUser();
    settingsActions.getDataButtons();
    settingsActions.getVisibleFields();
    settingsActions.getCompanySettings();
  }

  render() {
    const {
      users,
      impersonatedUser,
      isUsersLoading,
      customers,
      isVehiclesLoading,
    } = this.props;
    console.log(users);
    const { selectedUser, waitingInProgress } = this.state;
    const shouldDisplaySpinner = isVehiclesLoading || waitingInProgress;

    const impersonationEnabled = !!impersonatedUser;
    const hasSelectedUser = !!selectedUser;
    return (
      <div className="impersonation-manager">
        {shouldDisplaySpinner && <Spinner />}
        <div className="form-group row">
          <label className="col col-form-label" htmlFor="user-select">
            {locale.impersonationManager._selectUser}:
          </label>
          <div className="col">
            <UserSelector
              users={users}
              handleChange={this.handleUserChange}
              selectedUser={selectedUser}
              isLoading={isUsersLoading}
              customers={customers}
              isDisabled={impersonationEnabled}
            />
          </div>
        </div>
        <div className="button-row">
          <button
            className="btn btn-outline-dark mr-2"
            disabled={impersonationEnabled || !hasSelectedUser}
            onClick={this.startImpersonation}
          >
            {locale.impersonationManager._impersonate}
          </button>
          <button
            className="btn btn-outline-dark"
            disabled={!impersonationEnabled}
            onClick={this.stopImpersonation}
          >
            {locale.impersonationManager._stopImpersonation}
          </button>
        </div>
      </div>
    );
  }
}

ImpersonationManager.propTypes = {
  userActions: PropTypes.object.isRequired,
  authActions: PropTypes.object.isRequired,
  users: PropTypes.object.isRequired,
  impersonatedUser: PropTypes.string,
  impersonatedCustomerId: PropTypes.number,
  isUsersLoading: PropTypes.bool.isRequired,
  customers: PropTypes.array.isRequired,
  customerActions: PropTypes.object.isRequired,
  vehicleTrackingActions: PropTypes.object.isRequired,
  isVehiclesLoading: PropTypes.bool.isRequired,
  settingsActions: PropTypes.object.isRequired,
};

ImpersonationManager.defaultProps = {
  impersonatedUser: '',
  impersonatedCustomerId: null,
};

export default ImpersonationManager;
